import { Link } from "react-router-dom";
import { ArrowRight, Camera, ClipboardList, Search, BadgeIndianRupee, CheckCircle2, PackageCheck } from "lucide-react";
import { Reveal, MaskedLine, Overline } from "../components/Reveal";

const IMG = "https://images.unsplash.com/photo-1567113463300-102a7eb3cb26?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwZm9sZGVkJTIwY2xvdGhlc3xlbnwwfHx8fDE3ODY2ODg1Mjd8MA&ixlib=rb-4.1.0&q=85";

export default function TradeIn() {
  const steps = [
    { icon: Camera, t: "Submit Your Clothes", d: "Clear photographs of the actual garment — front, back and labels." },
    { icon: ClipboardList, t: "Tell Us About Them", d: "Brand name, size, age, how often worn, and honest condition." },
    { icon: Search, t: "We Evaluate", d: "Brand, condition, photographs, age, demand and resale potential." },
    { icon: BadgeIndianRupee, t: "Reusable → Cash", d: "Strong resale pieces receive a cash offer, paid after pickup inspection." },
    { icon: CheckCircle2, t: "Good → Cloth Cash", d: "Good pieces earn Cloth Cash for eligible JIGEL and AVAGINJA purchases." },
    { icon: PackageCheck, t: "Recovery → Small Cloth Cash", d: "Well-worn items can still earn a small Cloth Cash thank-you." },
  ];
  return (
    <div data-testid="sell-page">
      <section className="relative min-h-[80svh] flex items-center overflow-hidden">
        <div className="absolute inset-0"><img src={IMG} alt="Clothes ready to sell" className="w-full h-full object-cover" /></div>
        <div className="absolute inset-0 bg-ink/60" />
        <div className="relative max-w-[1600px] mx-auto px-5 md:px-10 w-full py-24">
          <p className="text-[11px] tracking-[0.35em] uppercase text-ivory/60 mb-8">Sell Your Clothes to Jigel</p>
          <h1 className="font-serif text-6xl sm:text-7xl lg:text-8xl tracking-tighter leading-[0.92] text-ivory">
            <MaskedLine delay={0.15}>Your closet</MaskedLine>
            <MaskedLine delay={0.35} className="italic font-light text-gold">has value.</MaskedLine>
          </h1>
          <p className="mt-8 max-w-md text-ivory/70 text-base lg:text-lg leading-relaxed">
            Sell clothes you no longer wear. Every item is evaluated — Reusable pieces earn Cash, Good pieces earn Cloth Cash, and well-worn pieces can join Recovery.
          </p>
          <Link to="/sell/start" data-testid="start-tradein-btn"
            className="group mt-10 inline-flex bg-gold text-ink px-8 py-4 text-[11px] tracking-[0.25em] uppercase items-center gap-3 hover:bg-ivory transition-colors duration-300">
            Start Selling <ArrowRight size={14} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </section>

      <section className="max-w-[1600px] mx-auto px-5 md:px-10 py-24 md:py-32">
        <Reveal><Overline>The Process</Overline>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4">How selling works.</h2>
        </Reveal>
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border">
          {steps.map((s, i) => (
            <Reveal key={s.t} delay={(i % 3) * 0.1} className="bg-ivory p-8 md:p-10">
              <s.icon size={22} strokeWidth={1} className="text-wine" />
              <h3 className="font-serif text-2xl mt-5">{s.t}</h3>
              <p className="mt-3 text-sm text-ink/55 leading-relaxed">{s.d}</p>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-14 border border-gold/50 bg-gold/5 p-8 md:p-10">
          <p className="text-[11px] tracking-[0.3em] uppercase text-gold">Our Standard</p>
          <p className="mt-4 font-serif text-2xl md:text-3xl leading-snug max-w-3xl">
            Not every item we receive becomes a JIGEL product. Only items that meet our resale standards are offered to another customer.
          </p>
          <p className="mt-4 text-sm text-ink/60 max-w-2xl leading-relaxed">
            Recovery items remain outside our resale collection. Items we can't responsibly accept are respectfully declined — no Cash or Cloth Cash is issued for declined items. Offers are created only after review; no value is guaranteed from form details alone.
          </p>
        </Reveal>
      </section>
    </div>
  );
}
